/* global Vue */
import DateObj from './Date'
import DateListEditor from './DateListEditor'

/**
 * @param string|Date date
 * @return string
 */
function serializeDate (date) {
	if (date == null) return null
	if (typeof date === 'string') return date
	return [
		date.getFullYear(),
		'0'.concat(date.getMonth() + 1).slice(-2),
		'0'.concat(date.getDate()).slice(-2)
	].join('-')
}

class Bridge {

	constructor(bridgeE, options) {
		options = Object.assign({
			numDate: 1,
			dateAutofill: false,
			timeAutofill: false
		}, options)

		// 入力データの正規化
		const data = (value => {
			try {
				const data = JSON.parse(value)
				if (!Array.isArray(data)) return Array(options.numDate).fill(null).map(e => DateObj.create())
				return data
			} catch (e) {
				return Array(options.numDate).fill(null).map(e => DateObj.create())
			}
		})(bridgeE.value)

		this.bridgeE = bridgeE

		this.container = this.createContainer()
		this.app = new Vue({
			data() {
				return {
					value: {
						items: data
					},
					options
				}
			},
			el: this.container,
			components: {
				DateListEditor
			},
			template: `<DateListEditor v-model="value" v-bind="options" />`,
			watch: {
				value: {
					deep: true,
					handler () {
						const items = this.value.items
							.filter(item => typeof item.date === 'string' || item.date instanceof Date)
							.map(item => {
								const sItem = {
									id: item.id,
									date: serializeDate(item.date),
									time_from: item.time_from,
									time_to: item.time_to,
								}
								if (options.dateRange) {
									sItem.date_to = serializeDate(item.date_to)
								}
								return sItem
							})
						bridgeE.value = JSON.stringify(items)
					}
				}
			}
		})
	}

	createContainer() {
		const container = document.createElement('div')
		const { bridgeE } = this
		bridgeE.parentNode.insertBefore(container, bridgeE)
		return container
	}
}

export default Bridge
